import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TablePagination,
  CircularProgress,
  TableFooter,
  Chip
} from "@mui/material";
import axiosInstance from "../../utilities/Axios";
import AlertDialog from "../AlertDialog/AlertDialog";
import TicketDialogBox from "./TicketDialogBox";
import { EDialogAction } from "../Enum/DialogActionEnum";
import { useTheme } from "../../Hooks/ThemeContext/ThemeContext";
import { LoadingStateContext } from "../../Hooks/LoadingContext/LoadingContext";
import { DeleteOutline, EditOutlined, OpenInNew } from "@mui/icons-material";

const TicketTable = (props: { filter: any }) => {
  const theme = useTheme();
  const [ticket, setTicket] = useState(null);
  const [ticketList, setTicketList] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [editDialogVisibility, setEditDialogVisibility] = useState(false);
  const [alertDialogVisibility, setAlertDialogVisibility] = useState(false);
  const [dialogAction, setDialogAction] = useState(EDialogAction.view);
  const { changeLoading, isLoading } = React.useContext(LoadingStateContext);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    getTicketList();
  }, [page,limit, props.filter]);

  const getTicketList = async () => {
    changeLoading(true);
    try {
      const response = await axiosInstance.get(
        `/v1/ticket?type_dom_corp=${theme.theme}&page=${page}&items_per_page=${limit}`,
        {
          params: props.filter,
        }
      );

      const data = response.data;
      setTicketList(data.result.data);
      setTotalItems(data.result.total);
    } catch (err) {
      console.log(err);
    } finally {
      changeLoading(false);
    }
  };

  const getTicketById = async (ticketId: number, action: EDialogAction) => {
    try {
      const response = await axiosInstance.get(`/v1/ticket/${ticketId}`, {});

      const data = response.data;

      setTicket(data.result);

      if (action == EDialogAction.edit) {
        
        setEditDialogVisibility(true);
        
      } else if (action == EDialogAction.view) {
        
        setEditDialogVisibility(true);
      } else if (action == EDialogAction.delete) {
        setAlertDialogVisibility(true);
      }
      setDialogAction(action);
    } catch (err) {
      console.log(err);
    }
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  function editDialogClose(action: EDialogAction) {
    setEditDialogVisibility(false);
    getTicketList();
  }

  function alertDialogClose(action: EDialogAction) {
    setAlertDialogVisibility(false);
    getTicketList();
  }

  return (
    <>
      <TicketDialogBox
        open={editDialogVisibility}
        onClose={editDialogClose}
        data={ticket}
        dialogAction={dialogAction}
      />
      <AlertDialog
        openAlert={alertDialogVisibility}
        onCloseAlert={alertDialogClose}
        data={ticket}
        action="ticket"
      />
      <Paper>
        <TableContainer component={Paper}>
          <Table aria-label="ticket table">
            <TableHead>
              <TableRow>
                <TableCell>Id</TableCell>
                <TableCell>Passport ID</TableCell>
                <TableCell>First Name</TableCell>
                <TableCell>Last Name</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading &&
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              }

              {!isLoading && ticketList.map((data: any) => (
                <TableRow key={data.id}>
                  <TableCell>{data.id}</TableCell>
                  <TableCell>{data.passport_no}</TableCell>
                  <TableCell>{data.first_name}</TableCell>
                  <TableCell>{data.last_name}</TableCell>
                  <TableCell>
                    {data.status == 'c' ? <Chip label="Completed" color="success" /> : <Chip label="Processing" color="warning" />}
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        getTicketById(data.id, EDialogAction.view);
                      }}
                    >
                      <OpenInNew />
                    </Button>{" "}
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => {
                        getTicketById(data.id, EDialogAction.edit);
                      }}
                    >
                      <EditOutlined />
                    </Button>{" "}
                    <Button
                      variant="contained"
                      color="error"
                      onClick={() => {
                        getTicketById(data.id, EDialogAction.delete);
                      }}
                    >
                      <DeleteOutline />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}

              {!isLoading && ticketList.length == 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No Data Found
                  </TableCell>
                </TableRow>

              )}

            </TableBody>
          <TablePagination
              rowsPerPageOptions={[5, 10, 25,]}
              count={totalItems}
              rowsPerPage={limit}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Table>
        </TableContainer>

      </Paper>
    </>
  );
};

export default TicketTable;
